import React, { forwardRef } from 'react';
export { useTheme } from './theme';
export type { Theme, ThemePreference } from './theme';
export const Button = forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'ghost' | 'danger' }>(
  function Button({ variant = 'secondary', className = '', type = 'button', ...props }, ref) {
    return <button {...props} ref={ref} type={type} className={`ui-button ui-button--${variant} ${className}`} />;
  },
);
export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className = '', ...props }, ref) { return <input {...props} ref={ref} className={`ui-input ${className}`} />; },
);
export function Surface({ className = '', ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div {...props} className={`ui-surface ${className}`} />;
}
export { ThemeMenu, ThemeMenu as ThemeSelect } from './ThemeMenu';
export { PanelState } from './PanelState';
export { containDialogFocus } from './dialogFocus';
